import { useEffect } from 'react';

import { EventUtils } from 'app/utils/event-utils';

export const useLeaveWhileLoading = (loading: boolean) => {
    useEffect(() => {
        if (loading) {
            EventUtils.addBeforeUnloadEventListener();
        } else {
            EventUtils.removeBeforeUnloadEventListener();
        }

        return () => {
            EventUtils.removeBeforeUnloadEventListener();
        };
    }, [loading]);
};
